module.exports = __webpack_public_path__ + "img/DDE.35eedea.svg";